import { render, staticRenderFns } from "./ConversationOpportunities.vue?vue&type=template&id=69f20ce6&"
import script from "./ConversationOpportunities.vue?vue&type=script&lang=js&"
export * from "./ConversationOpportunities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports